import { useEffect } from 'react';

const useManifestVersion = () => {
  const location = window.location;

  useEffect(() => {
    const manifestVersion = new URLSearchParams(location.search).get(
      'manifestVersion'
    );

    if (manifestVersion) {
      localStorage.setItem('manifestVersion', manifestVersion);
    }
  }, [location.search]);
};

export default useManifestVersion;
